/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_bookmark__itinerary_saved = /** @type {(inputs: {}) => string} */ () => {
	return `Route zu den Favoriten hinzugefügt`
};

const en_bookmark__itinerary_saved = /** @type {(inputs: {}) => string} */ () => {
	return `Route added to favorites`
};

const es_bookmark__itinerary_saved = /** @type {(inputs: {}) => string} */ () => {
	return `Ruta añadida a favoritos`
};

const fr_bookmark__itinerary_saved = /** @type {(inputs: {}) => string} */ () => {
	return `Itinéraire ajouté aux favoris`
};

const it_bookmark__itinerary_saved = /** @type {(inputs: {}) => string} */ () => {
	return `Percorso aggiunto ai preferiti`
};

const nl_bookmark__itinerary_saved = /** @type {(inputs: {}) => string} */ () => {
	return `Route toegevoegd aan favorieten`
};

const pt_bookmark__itinerary_saved = /** @type {(inputs: {}) => string} */ () => {
	return `Rota adicionada aos favoritos`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__itinerary_saved = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bookmark__itinerary_saved(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("bookmark__itinerary_saved", locale)
	if (locale === "de") return de_bookmark__itinerary_saved(inputs)
	if (locale === "en") return en_bookmark__itinerary_saved(inputs)
	if (locale === "es") return es_bookmark__itinerary_saved(inputs)
	if (locale === "fr") return fr_bookmark__itinerary_saved(inputs)
	if (locale === "it") return it_bookmark__itinerary_saved(inputs)
	if (locale === "nl") return nl_bookmark__itinerary_saved(inputs)
	return pt_bookmark__itinerary_saved(inputs)
};